module.exports = __webpack_public_path__ + "static/media/aboutus_bg@2x.7086b4b4.png";